// extracted by mini-css-extract-plugin
export default {"root":"FullScreenSpinner_root__npaAD"};